import React from "react";
import ProfessionalPatientsTable from "../shared/ProfessionalPatientsTable";

export default function DoctorPatients() {
  return (
    <ProfessionalPatientsTable
      queryKeyPrefix="doctorPatients"
      endpointBase="doctor-patients"
      backPath="/doctors"
      titleKey="Physicians.title_physician_patients"
      errorTitleKey="Physicians.error_loading_patients"
      errorBackLabelKey="Physicians.button_back_to_physicians"
      headerBackLabelKey="Physicians.button_back_to_physicians"
    />
  );
}
